import React from 'react';

import PropTypes from 'prop-types';

export default function OptionsDropdown({ children }) {
  return (
    <ul
      className='tw-z-[1] tw-m-0 tw-list-none tw-overflow-hidden tw-whitespace-nowrap tw-rounded-lg tw-border-1 tw-border-solid tw-border-blue-100 tw-bg-white tw-p-0 tw-shadow-sm'
      data-element-name='options-dropdown'
    >
      {children}
    </ul>
  );
}

OptionsDropdown.propTypes = {
  children: PropTypes.node.isRequired,
};
